export const GET_PRODUCT_REVIEW_LIST_LOAD = 'GET_PRODUCT_REVIEW_LIST_LOAD';
export const GET_PRODUCT_REVIEW_LIST_SUCCESS = 'GET_PRODUCT_REVIEW_LIST_SUCCESS';
export const GET_PRODUCT_REVIEW_LIST_FAIL = 'GET_PRODUCT_REVIEW_LIST_FAIL';
export const GET_PRODUCT_REVIEW_LIST_RESET = 'GET_PRODUCT_REVIEW_LIST_RESET';

export const POST_REVIEW_LOAD = 'POST_REVIEW_LOAD';
export const POST_REVIEW_SUCCESS = 'POST_REVIEW_SUCCESS';
export const POST_REVIEW_FAIL = 'POST_REVIEW_FAIL';
export const POST_REVIEW_RESET = 'POST_REVIEW_RESET';
